const pagePattern = /page=([0-9])*/;
const itemsPerPagePattern = /PS=[0-9]*/;
const subSearchPattern = /ss=[^&]*/;
const productQuantityPattern = /\/mq\/[0-9]*/;
const sortByPattern = /fs=[^&]*&csd=(ASC|DESC)/;
const pricePattern = /\/p\/[0-9]*-[0-9]*/;
const colorPattern = /\/c\/[0-9-]*/;
const ratingPattern = /\/r\/[0-5-]*/;
const prodTimePattern = /\/s\/[0-9]*/;
const imprintLocationCountPattern = /\/l\/[0-9]*/;
const imprintColorCountPattern = /\/m\/[0-9]*/;
const tagPattern = /\/t\/[0-9-]*/;
const paramPattern = /\/[cprlmst]\/[0-9]/;

const sortMap = [{ v: "string:-RelevenceScore", q: "fs=Relevance&csd=DESC", meta: "" }, // Typo in multiple projects: Relevence --> Relevance
{ v: "string:SellPrice1", q: "fs=LowestSellPrice&csd=ASC", meta: "Price Low-High" },
{ v: "string:-SellPrice1", q: "fs=LowestSellPrice&csd=DESC", meta: "Price High-Low" },
{ v: "string:MinOrderQty", q: "fs=MinOrderQty&csd=ASC", meta: "Minimum Quantity" },
{ v: "string:ProductName", q: "fs=ProductName&csd=ASC", meta: "Product Name" },
{ v: "string:ProductionTime", q: "fs=ProductionTime&csd=ASC", meta: "Production Time" },
{ v: "string:-AverageRating", q: "fs=AverageRating&csd=DESC", meta: "Rating" }];

export default class ProductListValues {
    constructor(itemsPerPage, isUserRegistered) {
        this.pagePattern = pagePattern;
        this.itemsPerPagePattern = itemsPerPagePattern;
        this.subSearchPattern = subSearchPattern;
        this.productQuantityPattern = productQuantityPattern;
        this.sortByPattern = sortByPattern;
        this.pricePattern = pricePattern;
        this.colorPattern = colorPattern;
        this.ratingPattern = ratingPattern;
        this.prodTimePattern = prodTimePattern;
        this.imprintLocationCountPattern = imprintLocationCountPattern;
        this.imprintColorCountPattern = imprintColorCountPattern;
        this.tagPattern = tagPattern;
        this.paramPattern = paramPattern;
        this.sortMap = sortMap;
        this.itemsPerPage = this.getItemsPerPage(itemsPerPage);
        this.isUserRegistered = this.getIsUserRegistered(isUserRegistered);
    }

    /**
     * Replaces the current URL and updates the document title, description, and keywords.
     * @param {string} newUrl The new URL to replace the current one.
     * @param {string} newTitle The new title for the document.
     * @param {string} newDescription The new description for the document.
     * @param {string} newKeywords The new keywords for the document.
     * @return {void}
     */
    replaceCurrentUrl(newUrl, newTitle, newDescription, newKeywords) {
        let old = window.location.href;
        let oldTitle = document.title;
        let oldKeywords = document.querySelectorAll('meta[name="keywords"]')[0] ? document.querySelectorAll('meta[name="keywords"]')[0].getAttribute('content') : '';
        let oldDescription = document.querySelectorAll('meta[name="description"]')[0].getAttribute('content') ?? '';
        let urlArray = old.split('/');
        let prot = urlArray[0];
        let host = urlArray[2];
        let url = prot + '//' + host;

        if ((newUrl.indexOf('?') === 0 && old.indexOf('?') > -1 && old.slice(old.indexOf('?')) != newUrl) || old.replace(url, '') != newUrl) {
            history.pushState({ title: oldTitle, keywords: oldKeywords, description: oldDescription }, '', old);
            history.replaceState({ title: newTitle, keywords: newKeywords, description: newDescription }, '', newUrl);
            document.title = newTitle;
        }
    };

    /**
     * Returns the number of items per page, defaulting to 50 if not provided.
     * @param {number} itemsPerPage The number of items per page.
     * @returns {number} The number of items per page.
     */
    getItemsPerPage(itemsPerPage) {
        return itemsPerPage || 50;
    }

    /**
     * Returns whether the user is registered.
     * @param {string} isUserRegistered The registration status as a string.
     * @returns {boolean} True if the user is registered, false otherwise.
     */
    getIsUserRegistered(isUserRegistered) {
        return isUserRegistered === "True";
    }
}